export default __webpack_public_path__ + "static/char-v-48-zh-Hant-eefc6046feedc52137ffe640d3e87e3f.mp4";